(function($) {
    var Controller ={
        standby:function(){
            this.view = {};
            this.view.window = $(window);
            this.view.window.on('load resize', this.imgRespon.bind(this));
            this.view.window.on('load', this.hamburger.bind(this));
        },
        imgRespon:function(){
            if(matchMedia('(min-width: 768px)').matches){
                $('.respon').each(function(){
                    $(this).attr('src',$(this).attr('src').replace('.sp','.pc'));
                });
            }else{
                $('.respon').each(function(){
                    $(this).attr('src',$(this).attr('src').replace('.pc','.sp'));
                });
            }
        },
        hamburger:function(){
            $(".hamburger").on("click",function(){
                $("header").toggleClass("active");
                $(this).toggleClass("active");
                $(".header_top_right").fadeToggle();
            });
            //リサイズ時のリセット処理
            this.view.window.on('load resize',function(){
                if(matchMedia('(min-width: 768px)').matches){
                    $("header").removeClass("active");
                    $(".hamburger").removeClass("active");
                    $(".header_top_right").removeAttr("style");
                }
            });
            if($('body').hasClass('home')){
                let ancrLink = $(".header_top_right").find("a[href*='#']");
                $(ancrLink).on("click",function(){
                    $("header").removeClass("active");
                    $('.hamburger').removeClass("active");
                    $(".header_top_right").removeAttr('style');
                });
            }
        },
    };
    Controller.standby();
})(jQuery);
